import { obtenerHeadersApi } from '@/providers/api';
import api2 from '@/providers/api2';
import RespuestaApi from '@/models/respuestas/resApi.model';
import { useConst } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ERROR, EXITO, PENDIENTE, VERIFICANDO } from './estadosFormularios';
import { tokenEstaExpirado } from '@/hooks/useRutasProtegidas';

export const useVerificarCuenta = <R = any>(
  endpoint: string,
  metodo: string
) => {
  const [params] = useSearchParams();
  const [captchaToken, setCaptchaToken] = useState<string>(null);
  const [resultado, setResultado] = useState<R>(null);
  const [estado, setEstado] = useState(PENDIENTE);
  const token = useConst(params.get('t'));

  const verificarCuenta = useCallback(async () => {
    try {
      if (token && endpoint.length > 0) {
        const ipClient = api2.defaults.headers['X-Client-IP'];
        const headers = {
          ...obtenerHeadersApi(token),
          'X-Client-IP': ipClient,
        };

        const {
          data: { resultado },
        } = await api2<RespuestaApi<R>>(endpoint, {
          method: metodo,
          headers,
          data: { captchaToken },
        });

        setResultado(resultado);
        return setEstado(EXITO);
      }
      // Si hay datos faltantes devuelvo error
      return setEstado(ERROR);
    } catch (err) {
      setEstado(ERROR);
    }
  }, [token, endpoint, metodo, captchaToken]);

  useEffect(() => {
    if (!token || tokenEstaExpirado(token)) {
      return setEstado(ERROR);
    }

    if (estado === PENDIENTE && captchaToken) {
      setEstado(VERIFICANDO);
      return;
    }
    if (estado === VERIFICANDO) {
      verificarCuenta();
    }
  }, [token, estado, verificarCuenta, captchaToken]);

  return { estado, token, resultado, setCaptchaToken, captchaToken };
};
